// Vendors
import React from 'react';
// Components
import { ErrorComponent } from 'components/error/error.component';
// Contexts
import { LayoutContextProvider } from 'components/layout/contexts/layout.context';
// Constants
import { ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS } from './constants/entrypoint-orchestrator-uncategorized.constants';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';

const EntrypointOrchestratorUncategorizedComponent = (): React.JSX.Element => (
  <LayoutContextProvider>
    <HeaderLayoutContentFullHeightStyled>
      <ErrorComponent {...ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS} />
    </HeaderLayoutContentFullHeightStyled>
  </LayoutContextProvider>
);

export { EntrypointOrchestratorUncategorizedComponent };
